import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";


@Component({
    selector: 'app-history-item',
    templateUrl: './history-pdf.component.html',
    styleUrls: ['./history-pdf.component.scss'],
    standalone: false
})
export class HistoryPdfModal implements OnInit {
  public resHtml: string = '';
  public pdfLoading: boolean = false;
  public pdfImageURL = 'assets/icons/documents/pdf-view.svg';
  public pdf: Map<string, ArrayBuffer> = new Map();
  public constructor(@Inject(MAT_DIALOG_DATA) public dataIn: any) {}

  public ngOnInit() {
    for (let i = 0; i < this.dataIn.length; i++) {
        this.pdf.set(this.dataIn[i].file_name, this.dataIn[i].content.data);
    }
  }
  public ngOnDestroy() {
    this.pdfLoading = false;
    this.dataIn = null;
    this.pdf.clear();
  }

  public gotToDownload(event: Event, item:any) {
    event.preventDefault();
    const pdfBuffer: ArrayBuffer = item.value;
    const arr = new Uint8Array(pdfBuffer);
    const blob = new Blob([arr], { type: 'application/pdf'});
    const fileUrl = URL.createObjectURL(blob);
    window.open(fileUrl, "_blank");
  }

  public mouseEnt(event: any) {
    event.stopPropagation();
    event.target.children[0].src = 'assets/icons/documents/pdf-view-hover.svg'
  }
  public mouseOut(event: any) {
    event.stopPropagation();
    event.target.children[0].src = 'assets/icons/documents/pdf-view.svg';
  }
}